import { withDependencies } from '@wix/thunderbolt-ioc'
import { ViewerModelSym } from '@wix/thunderbolt-symbols'
import { StyleUtilsDefinition as definition } from '@wix/viewer-service-style-utils/definition'
import { StyleUtilsService as impl } from '@wix/viewer-service-style-utils/implementations'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'
import type { ServiceProvider, ViewerModel } from '@wix/thunderbolt-symbols'
import type {
	IStyleUtilsDefinition,
	IStyleUtilsService,
	IStyleUtilsServiceConfig,
} from '@wix/viewer-service-style-utils/definition'

export const styleUtilsService = withDependencies(
	[ViewerModelSym],
	(
		viewerModel: ViewerModel
	): ServiceProvider<
			IStyleUtilsDefinition,
			(opts: ServiceFactoryOpts<IStyleUtilsServiceConfig>) => IStyleUtilsService
		> => {
		const config = { isResponsive: viewerModel.site.isResponsive }

		return {
			definition,
			impl,
			config,
			platformConfig: config,
		}
	}
)
